import { SpineExtended } from '@game-studio/arcade-base';
import { Spine } from 'pixi-spine';
import { ContextStateSubscriber } from './context-state-subscriber';

export class OptimizationService {
    public static get Instance(): OptimizationService {
        return this._instance || (this._instance = new OptimizationService());
    }
    private static _instance: OptimizationService;

    public optimizeOn(spine: Spine | SpineExtended) {
        spine.cacheAsBitmap = true;
        ContextStateSubscriber.subscribeObject(spine);
    }

    public optimizeOff(spine: Spine | SpineExtended) {
        spine.cacheAsBitmap = false;
        spine.updateTransform();
    }

    public runOptimizedSpine(spine: Spine | SpineExtended, method: () => void) {
        this.optimizeOff(spine);
        method();
        this.optimizeOn(spine);
        ContextStateSubscriber.subscribeObject(spine);
    }
}

export const optimizationService = OptimizationService.Instance;
